module.exports = __webpack_public_path__ + "static/img/thirdSwiper.98886b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdSwiper.png
// module id = bk9k
// module chunks = 1